import { render } from "./Home.vue?vue&type=template&id=2a176dea&scoped=true"
import script from "./Home.vue?vue&type=script&lang=js"
export * from "./Home.vue?vue&type=script&lang=js"

import "./Home.vue?vue&type=style&index=0&id=2a176dea&lang=scss&scoped=true"

import exportComponent from "/codebuild/output/src286570729/src/astaykov-ui/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2a176dea"]])

export default __exports__